"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnlyActiveModifierGroupsFromValid = exports.getOnlyValidModifierGroupsFromFull = exports.getAllModifierGroupOverridesFromCategories = exports.getFullModifierGroup = exports.getStudioModifierGroups = void 0;
const validation_1 = require("./validation");
const modifier_1 = require("./modifier");
const Pricing_1 = require("./Pricing");
const selections_1 = require("./selections");
const getStudioModifierGroups = (lineModifierGroups) => {
    return lineModifierGroups ? Object.values(lineModifierGroups) : [];
};
exports.getStudioModifierGroups = getStudioModifierGroups;
const getFullModifierGroup = (categories, modifierGroup, modifiers
// selections: any
) => {
    let fullModifiers = [];
    if (modifierGroup != null && modifierGroup.modifiers != null) {
        fullModifiers = modifierGroup.modifiers
            .map((modifierId) => {
            const modifier = modifiers.find((m) => m.id === modifierId);
            if (modifier) {
                return modifier;
            }
            else {
                return null;
            }
        })
            .filter((modifier) => {
            return !!modifier;
        });
    }
    return Object.assign({
        fullModifiers: fullModifiers,
    }, modifierGroup);
};
exports.getFullModifierGroup = getFullModifierGroup;
const getAllModifierGroupOverridesFromCategories = (fullStructure, modifierGroup) => {
    const overrides = {};
    fullStructure === null || fullStructure === void 0 ? void 0 : fullStructure.forEach((category) => {
        if (category != null) {
            const modifierGroupOverrides = category.modifierGroupOverrides;
            if (modifierGroupOverrides != null &&
                modifierGroupOverrides[modifierGroup.id] != null) {
                const override = modifierGroupOverrides[modifierGroup.id];
                Object.assign(overrides, override);
            }
        }
    });
    return overrides;
};
exports.getAllModifierGroupOverridesFromCategories = getAllModifierGroupOverridesFromCategories;
const getOnlyValidModifierGroupsFromFull = (fullStudioStructure, category, selections) => {
    var _a, _b;
    return (_b = (_a = category === null || category === void 0 ? void 0 : category.fullModifierGroups) === null || _a === void 0 ? void 0 : _a.filter((modifierGroup) => {
        return !!modifierGroup;
    })) === null || _b === void 0 ? void 0 : _b.filter((modifierGroup) => {
        return (0, validation_1.isModifierGroupValid)(fullStudioStructure, modifierGroup, selections);
    });
};
exports.getOnlyValidModifierGroupsFromFull = getOnlyValidModifierGroupsFromFull;
const getOnlyActiveModifierGroupsFromValid = (fullStudioStructure, validModifierGroups, selections) => {
    return validModifierGroups === null || validModifierGroups === void 0 ? void 0 : validModifierGroups.map((modifierGroup) => {
        // Validate all modifiers against full structure
        const validModifiers = (0, modifier_1.getAllValidModifiersForModifierGroup)(fullStudioStructure, modifierGroup, selections);
        const priceAdjustedValidModifiers = validModifiers === null || validModifiers === void 0 ? void 0 : validModifiers.map((modifier) => {
            const price = (0, Pricing_1.getModifierPrice)(modifier, selections);
            return Object.assign(Object.assign({}, modifier), { adjustedPriceMicros: price.price, adjustedPrice: price });
        });
        return Object.assign(Object.assign({}, modifierGroup), { fullModifiers: priceAdjustedValidModifiers, selectedModifiers: priceAdjustedValidModifiers === null || priceAdjustedValidModifiers === void 0 ? void 0 : priceAdjustedValidModifiers.filter((modifier) => (0, selections_1.isModifierSelected)(modifier === null || modifier === void 0 ? void 0 : modifier.id, selections)) });
    });
};
exports.getOnlyActiveModifierGroupsFromValid = getOnlyActiveModifierGroupsFromValid;
//# sourceMappingURL=modifierGroup.js.map